import {sortTableByMonth} from "../filter";
import {getUsageCSVDataLink} from "./usageCsvDownloadHelper";
import { DATE_FORMATS, formatDate } from "../dateUtils";

export const getUsageTable = (monthsBasedData, accountData) => {
    let tableRowsArr = [];
    for (const month in monthsBasedData) {
        let tableCol = [];
        tableCol.push(formatDate(month, DATE_FORMATS.MMM_YYYY));
        let totalNumberOfAccountsForTheMonth = countOfAccountForThatMonth(month, accountData.getAccountsArray());
        tableCol.push(totalNumberOfAccountsForTheMonth);
        let totalNumberOfBilledAcc = monthsBasedData[month].billedAccountsCount;
        tableCol.push(totalNumberOfBilledAcc);
        let total = monthsBasedData[month].totalBillingAmount.toFixed(2);
        tableCol.push(total);
        let discountAmount = monthsBasedData[month].totalDiscountAmount.toFixed(2);
        tableCol.push(discountAmount);
        let amountDue = (monthsBasedData[month].totalBillingAmount - monthsBasedData[month].totalDiscountAmount).toFixed(2);
        tableCol.push(amountDue);
        let downloadCSV = getUsageCSVDataLink("details_" + month, monthsBasedData[month].billingInfos, accountData.getAccountsObj());
        tableCol.push(downloadCSV);
        tableRowsArr.push(tableCol);
    }
    return tableRowsArr.sort(sortTableByMonth);
}

const countOfAccountForThatMonth = (month, accountData) => {
    let totalAccountCount = 0;
    let targetMonthDateObj = new Date(month);
    accountData.forEach((account) => {
        let accountMemberSinceDateObj = new Date(account.memberSince);
        if (isNaN(accountMemberSinceDateObj.getTime())) totalAccountCount++;
        else if (checkIfCreatedBefore(accountMemberSinceDateObj, targetMonthDateObj)) {
            totalAccountCount++;
        }
    });
    return totalAccountCount;
}

const checkIfCreatedBefore = (toBeCheckedDateObj, targetDateObj) => {
    if (targetDateObj.getFullYear() > toBeCheckedDateObj.getFullYear()) return true;
    else if (targetDateObj.getFullYear() === toBeCheckedDateObj.getFullYear()) {
        if (targetDateObj.getMonth() >= toBeCheckedDateObj.getMonth()) return true;
    }
    return false;
}
